import AsyncImport from './AsyncImport.vue'

export default AsyncImport
